export type ParsedResult = { parsed?: any; hasError: boolean; error?: unknown };

export const JsonTryParse = (text: string): ParsedResult => {
  try {
    const parsed = JSON.parse(text);
    return parsed ? { parsed, hasError: false } : { hasError: true };
  } catch (error) {
    return { hasError: true, error };
  }
};
